import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import NiceToSeeYou from "../../../views/fle/register/NiceToSeeYou"
import RegisteringLoadingIndicator from "../../../views/fle/register/RegistrationLoadingIndicator"
import { usePartnerRegistrationFlow } from "../PartnerRegistrationFlow"
import { useGetRegisteringPartner } from "../../hooks/usePartnerAccess"
import { HttpErrors } from "../../../../utils/HttpErrors"
import { CarrotErrorCodes } from "../../../../utils/CarrotErrors"
import { reportError } from "../../../../utils/ErrorReporting"
import { useHistory } from "react-router-dom"

export function WelcomeToCarrotStep(): JSX.Element {
  const { guid } = usePartnerRegistrationFlow()
  const { registeringUser, isRegisteringUserLoading, error } = useGetRegisteringPartner(guid)
  const { send } = useStateMachine(null)
  const history = useHistory()

  async function handleError() {
    if (error.name === HttpErrors.BAD_REQUEST) {
      const errorResponse = await error.response.json()
      switch (errorResponse.status) {
        case "ALREADY_REGISTERED":
          await history.replace(`/?errorCode=${CarrotErrorCodes.PARTNER_ALREADY_REGISTERED}`)
          return
        case "NONE":
        case "CANNOT_REGISTER":
          await history.replace(`/?errorCode=${CarrotErrorCodes.PARTNER_INVITE_INACTIVE}`)
          return
      }
    }
    // Catching issue with CORS and 404s as well, which both are not actionable
    if ([HttpErrors.NOT_FOUND, "FetchError"].includes(error.name)) {
      await history.replace("/")
      return
    }
    reportError(error)
  }

  if (isRegisteringUserLoading) {
    return <RegisteringLoadingIndicator />
  }

  if (error) {
    handleError()
    return null
  }

  if (registeringUser) {
    return <NiceToSeeYou companyName={registeringUser.companyName} onComplete={() => send("")} />
  }
}
